import axios from 'axios';
import config from '../../config';

const api = axios.create({
  baseURL: config.API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const exhibitionService = {
  getExhibitions: async () => {
    const response = await api.get('/exhibitions');
    return response.data;
  },
  
  // Eksik olan metodu ekleyelim
  getExhibitionsByCountry: async (countryId) => {
    try {
      console.log('Fetching exhibitions for country:', countryId);
      const response = await api.get(`/exhibitions/country/${countryId}`);
      console.log('Exhibitions response:', response.data);
      
      // API response formatı: { data: [...], log: {...}, message: "..." }
      if (response.data && response.data.data && Array.isArray(response.data.data)) {
        return response.data.data; // Wrapped format
      } else if (Array.isArray(response.data)) {
        return response.data; // Direkt array
      } else {
        console.error('Invalid data format:', response.data);
        return [];
      }
    } catch (error) {
      console.error('Error fetching exhibitions by country:', error);
      console.error('Error response:', error.response?.data);
      throw error;
    }
  },

  getExhibitionById: async (exhibitionId) => {
    const response = await api.get(`/exhibitions/${exhibitionId}`);
    return response.data;
  },
  
  addExhibition: async (data) => {
    const response = await api.post('/exhibitions', data, {  // endpoint'i /exhibitions olarak düzelttik
      headers: {
        'Content-Type': 'multipart/form-data'  // multipart/form-data için header
      }
    });
    return response.data;
  },
  
  deleteExhibition: async (id) => {
    const response = await api.delete(`/exhibitions/${id}`);
    return response.data;
  },
};

export default exhibitionService;